
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ExternalLink, Edit, Trash2 } from 'lucide-react';

interface PortfolioItemProps {
  id: string;
  title: string;
  description?: string;
  imageUrl?: string;
  projectUrl?: string;
  isOwner?: boolean;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
}

export const PortfolioItem: React.FC<PortfolioItemProps> = ({
  id,
  title,
  description,
  imageUrl,
  projectUrl,
  isOwner = false,
  onEdit,
  onDelete
}) => {
  return (
    <Card className="overflow-hidden">
      {imageUrl && (
        <div className="aspect-video w-full overflow-hidden">
          <img 
            src={imageUrl} 
            alt={title}
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <CardContent className="p-4">
        <div className="flex justify-between items-start mb-2">
          <h3 className="font-semibold text-lg dark:text-white">{title}</h3>
          {isOwner && (
            <div className="flex gap-2">
              {onEdit && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onEdit(id)}
                  className="h-8 w-8 p-0"
                >
                  <Edit className="h-4 w-4" />
                </Button>
              )}
              {onDelete && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onDelete(id)}
                  className="h-8 w-8 p-0 text-red-600 hover:text-red-700"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              )}
            </div>
          )}
        </div>
        
        {description && (
          <p className="text-gray-600 dark:text-gray-300 text-sm mb-3">{description}</p>
        )}
        
        {projectUrl && (
          <Button
            variant="outline"
            size="sm"
            asChild
            className="w-full"
          >
            <a href={projectUrl} target="_blank" rel="noopener noreferrer">
              <ExternalLink className="h-4 w-4 mr-2" />
              View Project
            </a>
          </Button>
        )}
      </CardContent>
    </Card>
  );
};
